
import { defineComponent, reactive, toRefs, onMounted, watch, ref } from "vue";
// import { selCms, selCmsMenu } from "@/api/index";
import router from "@/router";
import { userStore } from "@/store/index";
import { useRoute } from "vue-router";
import { CmsDetail } from "@/utils/CmsUtil";
export default defineComponent({
  props: ["titleId", "titleUrl"],
  setup(props, ctx) {
    const route = useRoute();
    const store = userStore();
    const data = reactive({
      cmsDetail: new CmsDetail(),
      menuList: Array<any>(),
      getMenuIndex: 0,
      flag: true,
      top: 0,
      headerColorFlag: true
    });
    const getCmsDetails = async () => {
      await store.selCmsDetail();
      data.cmsDetail = store.cmsDetail;
      ctx.emit("home-video", data.cmsDetail.cmsVideo);
    };

    const getCmsMenu = async () => {
      await store.selMenu();
      if (data.menuList.length == 0) {
        data.menuList = store.cmsMenuList;
      }
    };
    const getIndex = (url: string, index: number) => {
      if (index == 5) {
        data.getMenuIndex = 3;
      } else {
        data.getMenuIndex = index;
      }
      const aaa = document.getElementById(url);
      if (aaa) {
        aaa.scrollIntoView(true);
        // aaa.scrollIntoView({
        //   behavior: "smooth",
        //   block: "start"
        // });
      }
    };
    const titleJump = (url: string, index: number, id: string) => {
      if (index <= 2) {
        if (props.titleId == 3 || props.titleId == 4 || props.titleId == 5) {
          router.push({
            name: "Home",
            query: {
              // titleId: 2,
              titleUrl: url
            }
          });
        } else {
          const aaa = document.getElementById(url);
          if (aaa) {
            aaa.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "center"
            });
          }
        }
      } else if (index == 3) {
        router.push({
          name: "newsList",
          query: {
            id: id,
            titleId: index
          }
        });
      } else if (index == 4) {
        router.push({
          name: "aboutUs",
          query: {
            titleId: index,
            id: id
          }
        });
      }
    };
    let top = ref(0);
    onMounted(() => {
      getCmsMenu();
      getCmsDetails();
      getIndex(route.query.titleUrl as string, props.titleId);
      // 获取浏览器滚轮
      window.addEventListener("scroll", () => {
        top.value = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
        if (top.value > 5) {
          data.headerColorFlag = false;
        } else {
          data.headerColorFlag = true;
        }
      });
    });
    watch(top, (newValue, oldValue) => {
      if (newValue > oldValue) {
        data.flag = false;
      } else {
        data.flag = true;
      }
    });
    return {
      ...toRefs(data),
      getCmsDetails,
      getCmsMenu,
      titleJump,
      getIndex
    };
  }
});
